import { defineAppConfig } from 'ice';
import aem from '@/utils/aem';
import { defineSpmConfig } from '@ali/ice-plugin-spm/types';

window.onload = () => {
  aem();
};
function setRem() {
  const baseFontSize = 16;
  let screenWidth = document.documentElement.clientWidth || document.body.clientWidth;
  let scale;

  if (screenWidth >= 1680) {
    scale = screenWidth / (1680 / baseFontSize);
  } else if (screenWidth >= 1024 && screenWidth < 1680) {
    scale = baseFontSize;
  } else if (screenWidth <= 1024 && screenWidth >= 768) {
    scale = screenWidth / (1024 / (baseFontSize * 1.2));
  } else {
    scale = screenWidth / (768 / (baseFontSize * 1.5));
  }

  const htmlDom = document.getElementsByTagName('html')[0];
  htmlDom.style.fontSize = `${scale}px`;
}

// 初始化
setRem();
// 改变窗口大小时重新设置 rem
window.onresize = function () {
  setRem();
};

/**
 * @description 应用配置
 */
export default defineAppConfig(() => ({
  app: {
    rootId: 'app-container',
    errorBoundary: true,
  },
  router: {
    type: 'browser',
  },
}));

export const spmConfig = defineSpmConfig(() => {
  return {
    spmA: 'a2c_o01',
  };
});
